var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTransaction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 65.499 70.778 h 22.258 c 1.239 0 2.243 -1.004 2.243 -2.243 V 46.277 c 0 -0.683 -0.826 -1.025 -1.309 -0.542 l -2.706 2.706 c -0.876 0.876 -2.296 0.876 -3.172 0 L 45.516 11.144 c -0.876 -0.876 -2.296 -0.876 -3.172 0 L 30.366 23.122 c -0.876 0.876 -0.876 2.296 0 3.172 l 37.297 37.297 c 0.876 0.876 0.876 2.296 0 3.172 l -2.706 2.706 C 64.473 69.952 64.816 70.778 65.499 70.778 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(59,142,204)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0 43.723 l 0 -22.258 c 0 -1.239 1.004 -2.243 2.243 -2.243 h 22.258 c 0.683 0 1.025 0.826 0.542 1.309 l -2.706 2.706 c -0.876 0.876 -0.876 2.296 0 3.172 l 37.297 37.297 c 0.876 0.876 0.876 2.296 0 3.172 L 47.656 78.856 c -0.876 0.876 -2.296 0.876 -3.172 0 L 7.187 41.559 c -0.876 -0.876 -2.296 -0.876 -3.172 0 l -2.706 2.706 C 0.826 44.749 0 44.407 0 43.723 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(248,174,8)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransaction);
export default __webpack_public_path__ + "static/media/transaction.2395d7509d1f73869714e11b8f8beab1.svg";
export { ForwardRef as ReactComponent };